<script setup lang="ts">
import type { ISidebarMenuItem } from './'

const props = defineProps<Omit<ISidebarMenuItem, 'title'>>()
const { locale } = useI18n()

// Add locale prefix manually
const localizedUrl = computed(() => {
  const url = props.url
  // If not default locale (ru) and url doesn't start with locale prefix
  if (locale.value !== 'ru' && !url.startsWith(`/${locale.value}`)) {
    return `/${locale.value}${url}`
  }
  return url
})
</script>

<template>
  <NuxtLink
    :to="localizedUrl"
    class="SidebarMenuItemLink"
    :class="{ 'text-blue-600': props.isActive }"
  >
    <i v-if="props.icon" class="SidebarMenuItemLinkIcon"><UiIcon :name="props.icon" /></i>
    <slot />
  </NuxtLink>
</template>
